// src/components/Index.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import MainLayout from "../Layout/MainLayout";

import Landingpage from "../pages/landingpage/Layout5";
import MainDashboard from "../pages/profile/dashboard/MainDashboard";
import SurveyApp from "../pages/survey/Main";
import SurveyDashboard from "../pages/survey/SurveyDashboard";

const Index = () => {
  return (
    <Routes>
      <Route path="/" element={<SurveyApp />} />
      <Route path="/survey/results-for-team" element={<SurveyDashboard />}/>
      {/* <Route path="/profile" element={<MainLayout />}>
        <Route path="/profile/home" element={<MainDashboard />} />
      </Route> */}
    </Routes>

  );
};

export default Index;
